import Vue from 'vue'
import VueRouter from 'vue-router'

import { isEqual } from 'lodash'

import { createCaughtError, handleCaughtError } from '../errorInterception'

/**
 * Обрабатывает отклонение замены маршрута.
 *
 * Дубль навигации гасится по типу ошибки, остальные отклонения передаются в
 * перехват ошибок.
 *
 * @param {*} error Отклонение метода `replace` роутера.
 */
function handleReplaceRejection(error) {
  if (VueRouter.isNavigationFailure(error, VueRouter.NavigationFailureType.duplicated)) {
    return
  }

  handleCaughtError(createCaughtError('router', error))
}

export const routerReplacer = (route = {}) => {
  const currentRoute = Vue.router.currentRoute
  const nextRoute = {
    ...currentRoute,
    ...route
  }
  if (!isEqual(currentRoute, nextRoute)) {
    Vue.router.replace(nextRoute).catch(handleReplaceRejection)
  }
}

export const routerQueryReplace = (query = {}, removeHash = false) => {
  const currentRoute = Vue.router.currentRoute
  const nextQuery = {
    ...currentRoute.query,
    ...query
  }
  let nextHash = currentRoute.hash
  if (removeHash) {
    nextHash = undefined
  }

  const sameQuery = isEqual(currentRoute.query, nextQuery)
  const sameHash = currentRoute.hash === nextHash

  if (sameQuery && sameHash) {
    return
  }

  Vue.router.replace({
    ...currentRoute,
    query: nextQuery,
    hash: nextHash
  }).catch(handleReplaceRejection)
}

export const routerParamsReplace = (params = {}) => {
  const currentRoute = Vue.router.currentRoute
  Vue.router.replace({
    ...currentRoute,
    params: {
      ...currentRoute.params,
      ...params
    }
  }).catch(handleReplaceRejection)
}

export default {
  routerReplacer,
  routerQueryReplace,
  routerParamsReplace
}
